"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var useIsIos = function useIsIos() {
  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isIos = _useState2[0],
      setIsIos = _useState2[1];

  (0, _react.useEffect)(function () {
    if (typeof window !== 'undefined') {
      var _window, _window$navigator;

      setIsIos(/iPad|iPhone|iPod/.test(((_window = window) === null || _window === void 0 ? void 0 : (_window$navigator = _window.navigator) === null || _window$navigator === void 0 ? void 0 : _window$navigator.userAgent) || '_'));
    }
  }, []);
  return isIos;
};

__signature__(useIsIos, "useState{[isIos, setIsIos](false)}\nuseEffect{}");

var _default = useIsIos;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useIsIos, "useIsIos", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveHeader/Mobile/useIsIos.ts");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveHeader/Mobile/useIsIos.ts");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9SZXNwb25zaXZlSGVhZGVyL01vYmlsZS91c2VJc0lvcy50cyJdLCJuYW1lcyI6WyJ1c2VJc0lvcyIsImlzSW9zIiwic2V0SXNJb3MiLCJ3aW5kb3ciLCJ0ZXN0IiwibmF2aWdhdG9yIiwidXNlckFnZW50Il0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7OztBQUFBOzs7Ozs7Ozs7OztBQUVBLElBQU1BLFFBQVEsR0FBRyxTQUFYQSxRQUFXLEdBQU07QUFBQSxrQkFDSyxxQkFBUyxLQUFULENBREw7QUFBQTtBQUFBLE1BQ2RDLEtBRGM7QUFBQSxNQUNQQyxRQURPOztBQUVyQix3QkFBVSxZQUFNO0FBQ2QsUUFBSSxPQUFPQyxNQUFQLEtBQWtCLFdBQXRCLEVBQW1DO0FBQUE7O0FBQ2pDRCxNQUFBQSxRQUFRLENBQUMsbUJBQW1CRSxJQUFuQixDQUF3QixZQUFBRCxNQUFNLFVBQU4sK0RBQVFFLFNBQVIsd0VBQW1CQyxTQUFuQixLQUFnQyxHQUF4RCxDQUFELENBQVI7QUFDRDtBQUNGLEdBSkQsRUFJRyxFQUpIO0FBTUEsU0FBT0wsS0FBUDtBQUNELENBVEQ7O2NBQU1ELFE7O2VBV1NBLFE7Ozs7Ozs7Ozs7OzswQkFYVEEsUSIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IHVzZUVmZmVjdCwgdXNlU3RhdGUgfSBmcm9tICdyZWFjdCc7XG5cbmNvbnN0IHVzZUlzSW9zID0gKCkgPT4ge1xuICBjb25zdCBbaXNJb3MsIHNldElzSW9zXSA9IHVzZVN0YXRlKGZhbHNlKTtcbiAgdXNlRWZmZWN0KCgpID0+IHtcbiAgICBpZiAodHlwZW9mIHdpbmRvdyAhPT0gJ3VuZGVmaW5lZCcpIHtcbiAgICAgIHNldElzSW9zKC9pUGFkfGlQaG9uZXxpUG9kLy50ZXN0KHdpbmRvdz8ubmF2aWdhdG9yPy51c2VyQWdlbnQgfHwgJ18nKSk7XG4gICAgfVxuICB9LCBbXSk7XG5cbiAgcmV0dXJuIGlzSW9zO1xufTtcblxuZXhwb3J0IGRlZmF1bHQgdXNlSXNJb3M7XG4iXX0=